export const SET_SHOW_STAGE = 'MAIN_CONTAINER/SET_SHOW_STAGE'
export const SET_TWEEN_OBJECT_BUILDER =
  'MAIN_CONTAINER/SET_TWEEN_OBJECT_BUILDER'
export const SET_PLAY_COMPLETED = 'MAIN_CONTAINER/SET_PLAY_COMPLETED'
export const SET_HTML_ASSETS = 'MAIN_CONTAINER/SET_HTML_ASSETS'
export const TOGGLE_VOICEOVER_MODAL = 'MAIN_CONTAINER/TOGGLE_VOICEOVER_MODAL'
export const SET_TIMELINE_PANEL = 'MAIN_CONTAINER/SET_TIMELINE_PANEL'
export const OPEN_EDIT_TEXT_MODAL = 'MAIN_CONTAINER/OPEN_EDIT_TEXT_MODAL'
